import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { SmallButton } from "components/atoms/Button";
import * as React from "react";

const Body = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: "rgba(255,255,255,0.09803921568627451 )",
  padding: "21px",
  gap: "14px",
  borderRadius: "20px",
}));

const LeftSection = styled(Box)(({ theme }) => ({}));

const RightSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

const RightNameSection = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "4px",
}));

const RightDateSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
}));

const RightProgressSection = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
}));

const BlueIcon = styled(Box)(({ theme }) => ({
  backgroundColor: "#31ad49",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  padding: "3px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const YellowIcon = styled(BlueIcon)(({ theme }) => ({
  backgroundColor: "#ddb930",
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  color: "#ffffff",
  fontSize: "14px",
  paddingBottom: "4px",
}));

const DescriptionText = styled(Typography)(({ theme }) => ({
  color: "#ffffff",
  fontSize: "12px",
}));

const ByText = styled(Typography)(({ theme }) => ({
  color: "#c1c1c1",
  fontSize: "12px",
}));

const BlueNameText = styled(ByText)(({ theme }) => ({
  color: "#31ad49",
  fontSize: "12px",
}));

const YellowNameText = styled(BlueNameText)(({ theme }) => ({
  color: "#31ad49",
}));

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: "#31ad49",
  height: 1,
  padding: "0px !important",
  "& .MuiSlider-root": {
    padding: "0px",
  },
  "& .MuiSlider-thumb": {
    height: 0,
    width: 0,
    border: "1px solid currentColor",
    "&:hover": {
      boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)",
    },
    "& .airbnb-bar": {
      height: 4,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-track": {
    height: 1,
  },
  "& .MuiSlider-rail": {
    color: theme.palette.mode === "dark" ? "#bfbfbf" : "#d8d8d8",
    opacity: theme.palette.mode === "dark" ? undefined : 1,
    height: 3,
  },
}));

interface roadmapCardsProps {
  type: string;
  icon: string;
  title: string;
  name: string;
  role: any;
  description: string;
  protitle?: string;
  pronum?: any;
  date?: string;
  active?: boolean;
}

// eslint-disable-next-line no-empty-pattern
const RoadmapCards: React.FC<roadmapCardsProps> = ({
  type,
  icon,
  title,
  name,
  role,
  description,
  protitle,
  pronum,
  date,
  active,
}) => {


  const WifiOutlinedIcon = (  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
  <g id="Icon_feather-rss" data-name="Icon feather-rss" transform="translate(-5.5 -5.5)">
    <path id="Path_484" data-name="Path 484" d="M6,16.5a6.75,6.75,0,0,1,6.75,6.75" transform="translate(0 -5.25)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
    <path id="Path_485" data-name="Path 485" d="M6,6A12,12,0,0,1,18,18" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
    <path id="Path_486" data-name="Path 486" d="M7.5,27.75A.75.75,0,1,1,6.75,27,.75.75,0,0,1,7.5,27.75Z" transform="translate(0 -10.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
  </g>
</svg>);

  return (
    <Body style={{opacity: `${!active && 0.5}`}}>
      <LeftSection>
        {type === "blue" ? (
          <BlueIcon>
            {icon === "setting" ? (
              <SettingsOutlinedIcon
                style={{ fontSize: "25px", color: "#ffffff" }}
              />
            ) : icon === "refresh" ? (
              <AutorenewOutlinedIcon
                style={{ fontSize: "25px", color: "#ffffff" }}
              />
            ) : (
              WifiOutlinedIcon
            )}
          </BlueIcon>
        ) : (
          <YellowIcon>
            {icon === "setting" ? (
              <SettingsOutlinedIcon
                style={{ fontSize: "25px", color: "#ffffff" }}
              />
            ) : icon === "refresh" ? (
              <AutorenewOutlinedIcon
                style={{ fontSize: "25px", color: "#ffffff" }}
              />
            ) : (
              WifiOutlinedIcon
            )}
          </YellowIcon>
        )}
      </LeftSection>
      <RightSection>
        <TitleText>{title}</TitleText>
        <RightNameSection>
          <ByText>Developed by:&nbsp;&nbsp;</ByText>
          {type === "blue" ? (
            <BlueNameText>{name}&nbsp;</BlueNameText>
          ) : (
            <YellowNameText>{name}&nbsp;</YellowNameText>
          )}
          <SmallButton color={"none"} text={role} />
        </RightNameSection>
        <DescriptionText style={{ paddingBottom: "26px" }}>
          {description}
        </DescriptionText>
        {type === "blue" ? (
          <>
            {" "}
            <AirbnbSlider value={pronum} />
            <RightProgressSection style={{ paddingTop: "7px" }}>
              <DescriptionText>{protitle}</DescriptionText>
              <DescriptionText>{pronum}%</DescriptionText>
            </RightProgressSection>
          </>
        ) : (
          <RightDateSection>
            <ByText>Realease date</ByText>
            <TitleText>{date}</TitleText>
          </RightDateSection>
        )}
      </RightSection>
    </Body>
  );
};

export default RoadmapCards;
